// Case study screenshots provided by the client (real built sites)
const A = "https://customer-assets.emergentagent.com/job_957cab3d-66b6-48d6-9bdf-7ac9c6f1a982/artifacts";

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_studio-showcase-95/artifacts/gw1pind2_Screenshot%202026-05-08%20at%208.00.42%E2%80%AFpm-Photoroom%20%281%29.png";

export const caseStudies = [
  {
    client: "Nabata Media",
    industry: "Videography & Marketing",
    blurb: "A values-driven personal brand agency site engineered to convert visitors into booked discovery calls.",
    url: "https://nabatamedia.com/",
    image: `${A}/wkzequ4k_image.png`,
  },
  {
    client: "Abdali Prestige Tours",
    industry: "Luxury Travel",
    blurb: "An immersive, cinematic booking experience guiding travellers through curated destinations.",
    url: "https://abdaliprestigetours.com/",
    image: `${A}/nci0q0v1_image.png`,
  },
  {
    client: "Memo Parties",
    industry: "Event Stylist",
    blurb: "An elegant editorial showcase that turns event styling enquiries into planning consultations.",
    url: "https://memoparties.com.au/",
    image: `${A}/nwwvgd92_image.png`,
  },
  {
    client: "The Sparky Andy",
    industry: "Electrician",
    blurb: "A bold, trust-first trade website built for instant calls and free-quote conversions.",
    url: "https://sparkyandy.com/",
    image: "https://customer-assets.emergentagent.com/job_studio-showcase-95/artifacts/7jxb4smj_image.png",
  },
];

export const stats = [
  { value: "10+", label: "Sites Launched" },
  { value: "100%", label: "Client Retention" },
  { value: "2–4 wks", label: "Average Go-Live", note: "Varies on scope" },
  { value: "6+", label: "Industries Served", note: "Fitness & Wellness · Hospitality · Trade · Travel · Marketing · Education" },
];

export const process = [
  {
    step: "01",
    title: "Discovery Call",
    desc: "We start with a conversation — understanding your brand, your goals, and what your customers actually need.",
  },
  {
    step: "02",
    title: "Free Website Demo",
    desc: "No risk, no commitment. We design and build a live demo of your site so you can see the vision before you invest.",
  },
  {
    step: "03",
    title: "Revisions",
    desc: "We refine every detail together until it feels unmistakably yours — pixel-perfect and conversion-ready.",
  },
  {
    step: "04",
    title: "Finalise & Launch",
    desc: "We handle the technical lift and launch your site to the world, polished and built to perform.",
  },
];

export const INSTAGRAM_URL = "https://www.instagram.com/aestrics.studio/";
export const CALENDLY_URL = "https://calendly.com/aestrics/booking";
